import React, { Component } from "react";
import "./styles/css/index.css";
import "./styles/css/main.css";
import "./styles/css/App.css";
import "antd/dist/antd.css";
import { MyContext } from "./MyProvider";import {
  getSession,
} from "./components/general_functions/general";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Routes from "./Routes";
import WOW from "wowjs";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {user: ""};
  }

  componentDidMount() {
    getSession(res => {
      if (res.isLoggedIn) {
        this.context.state.login(res);
      }

      this.setState({
        user: res.user
      });
    });


    new WOW.WOW().init();
  }

  render() {
    return (
      <MyContext>
        {context => {
          this.context = context;
          const lang = context.state.language;
          return (
            <div className={lang < 2 ? "kurdish-font" : "english-font"}>
              <Router>
                <div style={{height: "100%"}}>
                  <Routes context={context.state} />
                </div>
              </Router>
            </div>
          );
        }}
      </MyContext>
    );
  }
}

export default App;
